export default __webpack_public_path__ + "static/media/card.8eb31447.jpg";